import { raise } from 'xstate5';

import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const raiseGenerateMixedDressingDetailsEvent: CustomizationMachineAction = raise({
  type: 'customization.dressing-mode.generate-mixed-dressings-details',
});
